import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "../../../../utils"

export const TeamModuleCarouselFragment = graphql(
  `
    fragment TeamModuleCarousel on CollectionTeamModule {
      title
      description
      sections {
        id
        name
        title
        bio
        media {
          ...MediaProps
        }
      }
    }
  `,
  [getMediaPropsFromMediaFragment],
)
